// extracted by mini-css-extract-plugin
module.exports = {"center":"SignupSurvey_center__3Q2iN","resendCode":"SignupSurvey_resendCode__3yj53"};